import { Flex, Select, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_PAGE_SIZE = 30;

type Props = {
  defaultPageSize?: number;
  onChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
};

export const TablePageSizeSelector: FC<Props> = ({
  defaultPageSize = DEFAULT_PAGE_SIZE,
  pageSizeOptions = [DEFAULT_PAGE_SIZE, 50, 100],
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Flex gap="small" align="center">
      <Text text={t('display-page-size')} weight="regular" />

      <Select
        defaultValue={defaultPageSize}
        style={{ width: 120 }}
        onChange={onChange}
        value={defaultPageSize}
        options={pageSizeOptions.map((value) => {
          return {
            value,
            label: t('number-with-unit', { number: value }),
          };
        })}
      />
    </Flex>
  );
};
